<template>
  <div>
    <div class="disFlex between curse-search">
      <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="">
            <el-select v-model="formInline.parentid" placeholder="全部试卷类别" clearable>
              <el-option-group v-for="group in options" :key="group.uniqueCode" :label="group.text"
                style="width: 100%;">
                <el-option v-for="item in group.children" :key="item.uniqueCode" :label="item.text"
                  :value="item.uniqueCode">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-loading="loading" style="padding: 10px;background-color: #fff;">
      <el-table :data="tableData.rows" style="width: 100%;margin-bottom: 20px;" row-key="id" border>
        <el-table-column prop="papersname" fixed label="试卷名称">
        </el-table-column>
        <el-table-column prop="createTime" width="220" label="考试时间" sortable>
        </el-table-column>

        <el-table-column prop="itypename" label="试卷类型" sortable>
        </el-table-column>
        <el-table-column prop="fraction" width="90" label="分数" sortable>
        </el-table-column>
        <!-- <el-table-column prop="state" label="状态" sortable>
          <template slot-scope="scope">
            <el-link type="primary" v-if="scope.row.state==2">已考试</el-link>
            <el-link type="info" v-if="scope.row.state==0">未开始</el-link>
            <el-link type="danger" v-if="scope.row.state==1">考试中</el-link>
          </template>
        </el-table-column> -->

        <el-table-column prop="state" fixed="right" width="120" label="操作" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="查看" placement="top">
              <el-button size="mini" circle type="success" icon="el-icon-view" @click="toDetail(scope.row.id,1)">
              </el-button>
            </el-tooltip>

            <el-tooltip v-if="scope.row.fraction>=80" class="item" effect="dark" content="电子证件查看" placement="top">
              <el-button size="mini" circle type="primary" icon="el-icon-s-order" @click="getCard(scope.row)">
              </el-button>
            </el-tooltip>
            <!-- <el-tooltip v-if="scope.row.state==1" class="item" effect="dark" content="进入考试" placement="top">
              <el-button size="mini" circle type="primary" icon="el-icon-view" @click="toKaoshi(scope.row.id,1)">
              </el-button>
            </el-tooltip> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px;text-align: right;" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="formInline.page" :page-sizes="[10, 20, 30, 50]"
        :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total">
      </el-pagination>
    </div>
    <!-- 证件查看 -->
    <el-dialog title="证书详情" :visible.sync="dialogVisible" width="900px" :destroy-on-close="true">
      <div>
        <!--  style="height: 600px;overflow-y: auto;" -->
        <div id="firefoxA" style="display:none;"></div>
        <div id="allcarddiv">
          <div id="page1">
            <div class="pxcard-title1">
              河南省职业健康培训
            </div>
            <div class="pxcard-title2">
              合格证书
            </div>
            <div class="pxcard-yw">
              <div class="heng"></div>CERTIFICATE<div class="heng"></div>
            </div>
            <div class="pxcard-number">NO.{{activeCard.card}}</div>
            <div class="pxcard-wz">
              <div class="pxcard-ch">
                <span class="pxcard-nr" style="padding: 0 15px;">{{activeCard.REAL_NAME}}</span>先生/女士
              </div>
              <div class="pxcard-cont">
                所属单位：
                <span class="pxcard-nr" v-for="(item,i) in activeCard.entnameArr" :style="i==0?'padding-left:5px;':((i==activeCard.entnameArr.length-1)?'padding-right:5px;':'')">{{item}}</span>
                于{{activeCard.year}}年参加
                <span class="pxcard-nr" v-for="(item,i) in activeCard.pxnameArr" :style="i==0?'padding-left:5px;':((i==activeCard.pxnameArr.length-1)?'padding-right:5px;':'')">{{item}}</span>
                ，培训内容：
                <span class="pxcard-nr" v-for="(item,i) in activeCard.cnameArr" :style="i==0?'padding-left:5px;':((i==activeCard.cnameArr.length-1)?'padding-right:5px;':'')">{{item}}</span>。
              </div>
              <div>
                成绩合格，特发此证!
              </div>
              <div style="text-align: right;line-height: 35px;position: absolute;right: 70px;bottom: 150px;">
                <div>河南广通安全评价有限公司</div>
                <div>{{activeCard.time}}</div>
              </div>
              <div style="text-align: right;line-height: 35px;position: absolute;right: 70px;bottom: 124px;">
                <img src="/static/images/gtzhang.png" />
              </div>
              <div
                style="text-align: right;line-height: 35px;position: absolute;left: 100px;bottom: 130px;width: 100px;text-align: center;">
                <div id="qrCodeDiv" ref="qrCodeDiv"></div>
                <div>防伪查询</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="isXz">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="xzBtn">下载</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  // 可生成二维码
  import QRCode from 'qrcodejs2';
  import {
    getItype
  } from '@/assets/js/common.js';
  import BaomingList from '../common/BaomingList';

  import html2canvas from 'html2canvas';
  import {
    format
  } from '@/assets/js/common.js';
  import {
    set
  } from 'vue';
  export default {
    props: ['collapse', 'wjSrc', 'currentUser'],
    data() {
      return {
        formInline: {
          parentid: '',
          page: 1,
          rows: 10,
          creator: ''
        },
        tableData: {
          rows: [],
          total: 0
        },
        circleUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
        options: [],
        dialogVisible: false,
        selectUserIds: [],
        selectIdArr: [],
        selectRows: [],
        bmparams: {},
        loading: true,
        activeCard: {
          entname: '',
          entnameArr: [],
          pxnameArr: [],
          cnameArr: []
        },
        cardKclist: [],
        isXz: true,
        qrcodeobj: null
      }
    },
    methods: {

      xzBtn: function() {
        html2canvas(document.getElementById('page1'), {
          scale: 2,
          allowTaint: true,
          useCORS: true,
          onrendered: function(canvas) {

          }
        }).then(function(canvas) {
          // document.body.appendChild(canvas);
          canvas.id = "mycanvas";
          canvas.toBlob(
            //传入blob对象
            function(blob) {
              //创建一个img标签
              var newImg = document.createElement("img"),
                //以blob对象为基础创建一个url
                url = URL.createObjectURL(blob)
              newImg.onload = function() {
                //加载后销毁
                // URL.revokeObjectURL(url);
                var aEle = document.createElement("a");
                aEle.href = url;

                aEle.download = "img.png";
                document.getElementById('firefoxA').appendChild(aEle);
                aEle.click();
              };

              //img标签属性赋值
              newImg.src = url;
              //添加为子元素
              document.body.appendChild(newImg);
            });
        });
      },
      getcurseList: function() {
        this.loading = true;
        this.$axios.get('/kt/ktQuestionsUser/getlistPage.htm?' + this.$qs.stringify(this.formInline), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '0') {
            this.$message.error(data.message);
          } else {
            this.tableData = data;
          }
          this.loading = false;
        })
      },
      toDetail: function(id) {
        sessionStorage.setItem('myanswerId', id)
        this.$router.push('/Ckjx?ismy=1');
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      showBm: function(id, name, itype, cid, isUser) {
        isUser = isUser ? isUser : [];
        this.bmparams = {
          productname: name,
          productid: id,
          itype: itype,
          cid: cid,
          isUser: isUser
        };
        var selectUserIds = [];
        isUser.map((item) => {
          selectUserIds.push(item.id);
        });
        this.selectUserIds = selectUserIds;
        this.dialogVisible = true;
      },
      changeBb: function(selectIdArr, selectRows) {
        this.selectIdArr = selectIdArr;
        this.selectRows = selectRows;
      },
      // 跳转准备考试的界面
      toKaoshi: function(id) {
        this.$router.push("/Ready?id=" + id);
      },
      delCurse: function(id) {
        var $this = this;
        this.$confirm('您确定要删除该课程吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$axios.post('/kt/ktProductAppy/allocation.htm', this.$qs.stringify({id:id})).then(res => {
          //   var data = res.data;
          //   if (data.stat == '1') {
          //     this.$message({
          //       message: data.message,
          //       type: 'success',
          //       onClose: function() {
          //         $this.getcurseList(1)
          //       }
          //     });
          //   } else {
          //     this.$message.error(data.message);
          //   }
          // })
        }).catch(() => {});
      },
      // 获取证件详情
      getCard(row) {
        this.qrcodeobj ? this.qrcodeobj.clear() : ''
        this.$axios.get('/kt/ktCardUser/getMyCard.htm?uid=' + this.currentUser.id + '&productid=' + row.productid).then(
          res => {
            var data = res.data;
            if (data.stat == '1') {
              var obj = data.data[0];
              obj.entnameArr = obj.entname.split('');
              var pxname = '“ 河南省';
              obj.ontype == 'ZXKT_producttype_2_2' ? pxname += '医学放射类' : pxname += '职业健康';
              obj.product_pxxz == '1' ? pxname += '主要负责人【初次培训】' : '';
              obj.product_pxxz == '2' ? pxname += '主要负责人【继续教育】' : '';
              obj.product_pxxz == '3' ? pxname += '管理人员【初次培训】' : '';
              obj.product_pxxz == '4' ? pxname += '管理人员【继续教育】' : '';
              pxname += '培训 ”'
              obj.pxnameArr = pxname.split('');
              obj.time = format('YYYY年MM月DD日',new Date(row.createTime));
              obj.year = format('YYYY',new Date(row.createTime));
              this.activeCard = {
                time: row.createTime.substring(0, 10),
                ...obj
              };
              this.dialogVisible = true
              var $this = this;
              setTimeout(function() {
                $this.qrcodeobj = new QRCode($this.$refs.qrCodeDiv, {
                  text: 'http://tsgt2023.tsanquan.com/pagehse/webwh/xmgs/detailzyws.html?uid=' + $this
                    .currentUser.id + '&productid=' + row.productid,
                  width: 100,
                  height: 100,
                  iconSrc: "/static/images/zhawlogol.png",
                  iconRadius: 0,
                  iconBorderWidth: 3,
                  colorDark: "#333333", //二维码颜色
                  colorLight: "#ffffff", //二维码背景色
                  correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
                });
              }, 1000)
              // return;
              if (obj.ontype == 'ZXKT_producttype_2_2') {
                this.cardKclist = [{
                  cname: '放射卫生相关法律法规解诶',
                  index: 1,
                  score: '合格'
                }, {
                  cname: '电离福射基础与放射诊疗安全和防护',
                  index: 2,
                  score: '合格'
                }, {
                  cname: '医疗机构职业健康与应急管理',
                  index: 3,
                  score: '合格'
                }, {
                  cname: '放射卫生纠纷防范',
                  index: 4,
                  score: '合格'
                }]
              } else if (obj.ontype == 'ZXKT_producttype_2_1') {
                if (obj.product_pxxz == 1 || obj.product_pxxz == 3 || obj.product_pxxz == 4) {
                  this.cardKclist = [{
                    cname: '形势与政策',
                    index: 1,
                    score: '合格'
                  }, {
                    cname: '职业健康基础知识',
                    index: 2,
                    score: '合格'
                  }, {
                    cname: '职业健康管理知识',
                    index: 3,
                    score: '合格'
                  }, {
                    cname: '案例分析',
                    index: 4,
                    score: '合格'
                  }, {
                    cname: '职业健康相关工作',
                    index: 5,
                    score: '合格'
                  }]
                } else if (obj.product_pxxz == 2) {
                  this.cardKclist = [{
                    cname: '形势与政策',
                    index: 1,
                    score: '合格'
                  }, {
                    cname: '职业健康管理知识',
                    index: 2,
                    score: '合格'
                  }, {
                    cname: '案例分析',
                    index: 3,
                    score: '合格'
                  }, {
                    cname: '职业健康相关工作',
                    index: 4,
                    score: '合格'
                  }]
                };
              }
              var arrn = this.cardKclist.map((item, i) => {
                if (i == 0) {
                  return item.cname
                } else {
                  return '/' + item.cname
                }
              });
              var cnamestr = arrn.join('').split('');
              this.activeCard.cnameArr = cnamestr;
              this.dialogVisible = true
            } else {
              this.$message.error(data.message);
            }
          })
      }
    },
    created: function() {
      this.$set(this.formInline, 'creator', this.currentUser.id);
      getItype(this.$axios, ((res) => {
        this.options = res;
      }));
    },
    components: {
      BaomingList
    },
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getcurseList(1);
        },
        deep: true //true 深度监听
      }
    }
  }
</script>

<style>
  .curse-search {
    padding: 20px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin: 20px auto;
  }

  .curse-search .el-form-item {
    margin-bottom: 0;
  }

  .curseInfoBlock {
    width: 256px;
    height: 256px;
    opacity: 1;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
    margin: 0 20px 20px 0;
  }

  .curseevery-title {
    width: 236px;
    height: 40px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 20px;
    margin: 8px auto;
  }

  .curseevery-title span {
    width: 34px;
    height: 16px;
    opacity: 1;
    background: linear-gradient(126deg, #ff7254 11%, #ff1515 90%);
    border-radius: 6px 6px 6px 0px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.05);
    color: #fff;
    font-size: 12px;
    display: inline-block;
    line-height: 16px;
    text-align: center;
    margin-right: 2px;
  }

  .curseevery-bot {
    width: 256px;
    height: 43px;
    opacity: 1;
    background: #fbfbfc;
    border-top: 1px solid #efefef;
    align-items: center;
    color: #9a9a9a;
    font-size: 13px;
    cursor: pointer;

  }

  .curseevery-bot img {
    margin-right: 4px;
  }

  .curseevery-top {
    position: relative;
  }

  .curseevery-top.ygq::after {
    content: "";
    content: '';
    display: block;
    width: 46px;
    height: 46px;
    background: url(../../assets/images/ygq.png) no-repeat;
    background-size: 46px 46px;
    position: absolute;
    right: 0;
    top: -1px;
  }

  .delVurse {
    position: absolute;
    width: 100%;
    height: 100%;
    display: none;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    align-items: center;
    justify-content: center;
    transition: all 0.3s linear;
  }

  .delVurse span {
    cursor: pointer;
    font-size: 14px;
    color: #ff1515;
  }

  .curseevery-top:hover .delVurse {
    display: flex;
  }

  #page1 {
    background: url('/static/images/cardnewbg1.png') 0 0 no-repeat;
    background-size: 100% 100%;
    font-size: 16px;
    width: 859px;
    height: 637px;
    color: #371b17;
  }

  .pxcard-title1 {
    text-align: center;
    font-size: 16px;
    letter-spacing: 12px;
    padding-top: 127px;
  }

  .pxcard-title2 {
    text-align: center;
    font-size: 50px;
    font-weight: 800;
    letter-spacing: 14px;
  }

  .pxcard-yw {
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 2px;
  }

  .pxcard-yw .heng {
    width: 54px;
    height: 1px;
    background: #9a9a9a;
    margin: 10px;
  }

  .pxcard-number {
    text-align: right;
    letter-spacing: 2px;
    padding-right: 50px;
  }

  .pxcard-wz {
    padding: 0px 50px;
    font-size: 16px;
    letter-spacing: 2px;
    line-height: 35px;
  }

  .pxcard-cont {
    text-indent: 2em;
  }

  .pxcard-nr {
    line-height: 25px;
    display: inline-block;
    border-bottom: 1px solid #9a9a9a;
    text-indent: 0em;
  }
</style>



// WEBPACK FOOTER //
// src/components/xueyuan/Mykaoshi.vue